import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { RoomDetails } from '../modal/room';

export interface RoomDetailsForm {
  fieldName: string;
}

export const createRoomAPI = async (roomDetails: RoomDetailsForm) => {
  const resp = await baseAPI.post<RoomDetails>(
    '/custom-form/room',
    roomDetails,
  );
  return resp.data;
};

export const useCreateRoomMutation = () => {
  return useMutation({
    mutationFn: async (roomDetails: RoomDetailsForm) => {
      const response = await createRoomAPI(roomDetails);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ROOMS],
      });
    },
  });
};
